var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23,24c-0.3,0-0.5-0.1-0.7-0.3l-22-22c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l22,22c0.4,0.4,0.4,1,0,1.4 C23.5,23.9,23.3,24,23,24z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19,13.5c-0.2,0-0.5-0.1-0.6-0.2c-0.6-0.5-1.3-1-2.1-1.4c-0.5-0.2-0.7-0.8-0.5-1.3s0.8-0.7,1.3-0.5 c0.9,0.4,1.7,1,2.5,1.6c0.4,0.4,0.5,1,0.1,1.4C19.6,13.4,19.3,13.5,19,13.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,13.5c-0.3,0-0.6-0.1-0.8-0.4c-0.4-0.4-0.3-1.1,0.1-1.4C6,10.4,7.9,9.5,10,9.2c0.6-0.1,1.1,0.3,1.2,0.8 c0.1,0.5-0.3,1.1-0.8,1.2c-1.7,0.3-3.4,1-4.7,2.2C5.5,13.5,5.2,13.5,5,13.5z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.6,10c-0.2,0-0.5-0.1-0.7-0.2c-3-2.7-7.1-4-11.1-3.7c-0.5,0-1-0.4-1.1-0.9c0-0.6,0.4-1,0.9-1.1 c4.6-0.4,9.2,1.2,12.6,4.2c0.4,0.4,0.5,1,0.1,1.4C23.1,9.9,22.9,10,22.6,10z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.4,10c-0.3,0-0.6-0.1-0.8-0.3c-0.4-0.4-0.3-1,0.1-1.4c1.5-1.3,3.2-2.3,5-3.1C6.3,5,6.8,5.2,7.1,5.8 c0.2,0.5,0,1.1-0.6,1.3C4.9,7.7,3.4,8.6,2.1,9.7C1.9,9.9,1.7,10,1.4,10z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.5,17.1c-0.2,0-0.4-0.1-0.6-0.2c-1.7-1.2-4.1-1.2-5.8,0c-0.5,0.3-1.1,0.2-1.4-0.2c-0.3-0.5-0.2-1.1,0.2-1.4 c2.4-1.7,5.7-1.7,8.1,0c0.5,0.3,0.6,0.9,0.2,1.4C16.1,17,15.8,17.1,15.5,17.1z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,21c-0.6,0-1-0.4-1-1s0.4-1,1-1h0c0.6,0,1,0.4,1,1S12.6,21,12,21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkError);
export default __webpack_public_path__ + "static/media/network-error.4d762359c8b26251cd1b04ce49dae4ea.svg";
export { ForwardRef as ReactComponent };